import React from 'react';
import { observer } from 'mobx-react-lite';

import { ITagItemProps, TagItem } from './TagItem';

export interface ITagItemSelectableProps
  extends Omit<ITagItemProps, 'isActive'> {}

export const TagItemSelectable = observer(
  ({ onPress, item }: ITagItemSelectableProps) => {
    return (
      <TagItem
        onPress={onPress}
        item={item}
        isActive={item.isSelected}
      />
    );
  },
);
